import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Calendar } from 'lucide-react';

export const SubsidyHero = ({ scheme, schemeId }) => (
  <section className={`py-20 bg-gradient-to-br ${scheme.color} relative overflow-hidden`}>
    <div className="absolute inset-0 opacity-10">
      <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
    </div>
    <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
      <Link 
        to="/subsidies" 
        className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-6 transition-colors"
      >
        <ArrowLeft size={18} />
        Back to All Schemes
      </Link>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="flex items-center gap-4 mb-4">
          <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center text-white">
            {scheme.icon}
          </div>
          <div>
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-white">
              {scheme.name}
            </h1>
            <p className="text-white/80 text-lg">{scheme.fullName}</p>
          </div>
        </div>
        <p className="text-xl text-white/90 max-w-3xl mt-4">{scheme.tagline}</p>
        <div className="flex items-center gap-2 mt-4 text-white/70">
          <Calendar size={16} />
          <span>Valid till: {scheme.validTill}</span>
        </div>
      </motion.div>
    </div>
  </section>
);
